import { Widget } from "@typeform/embed-react";
import { useUser } from "@src/hooks";
import styles from "./ScheduleSupportCallModal.module.scss";

type Props = {
  open: boolean;
  onClose: () => void;
  /** Optional override for lesson name (e.g. when opened from lesson context) */
  lessonName?: string;
  /** Optional override for country (e.g. when opened from lesson context) */
  country?: string;
};

const SUPPORT_CALL_TYPEFORM_ID = "nftVJf4A";

function ScheduleSupportCallModal({
  open,
  onClose,
  lessonName = "",
  country = "",
}: Props) {
  const [user] = useUser();

  if (!open) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.typeFormContainer}>
        <Widget
          id={SUPPORT_CALL_TYPEFORM_ID}
          hidden={{
            account: user?.customer?.name ?? "",
            school: user?.schools?.[0]?.name ?? "",
            course: "standalone",
            unit: "",
            country,
            lesson: lessonName,
            email: user?.email ?? "",
          }}
          onSubmit={onClose}
        />
      </div>
    </div>
  );
}

export default ScheduleSupportCallModal;
